import React from 'react'
import * as faker from 'faker'
import { storiesOf } from '@storybook/react'
import { action } from '@storybook/addon-actions'

import { IContestEntry, IContestScoreDetails } from 'protos'

import EventRanking from 'components/EventRanking'

const entries: IContestEntry[] = (new Array<IContestEntry>(10)).fill({}).map((_, i) => ({
  user: {
    name: faker.name.findName(),
    userId: faker.random.uuid(),
    photoUrl: faker.image.avatar(),
  },
  rank: i + 1,
  prize: i < 3 && [{
    money: { currency: 0, value: 300 - i * 100 },
  }],
  rankDelta: i === 0 ? 1 : ( i === 1 ? -1 : 0 ),
  score: 3545 - i * 145,
  details: (new Array<IContestScoreDetails>(5)).fill({}).map((__, j) => ({
    live: j === 0,
    match: {
      homeTeam: { name: faker.address.city() },
      awayTeam: { name: faker.address.city() },
    },
    score: (3545 - i * 145) / 5,
  } as IContestScoreDetails)),
} as IContestEntry))

storiesOf('EventRanking', module)
  .add('default', () => (
    <EventRanking entries={entries} onClickAvatar={action('onClickAvatar')} />
  ))
